// Performance optimization utilities

import { initializeLCPOptimizations } from './lcpOptimization';

// Preload critical resources
export const preloadCriticalResources = () => {
  const criticalImages = [
    '/src/assets/HeroImage1.png',
    '/src/assets/HeroImage2.png', 
    '/src/assets/HeroImage3.png',
    '/src/assets/logo.png',
    '/src/assets/HeroBook1.png'
  ];

  criticalImages.forEach((src, index) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    link.fetchPriority = index < 2 ? 'high' : 'low'; // First two images get high priority
    document.head.appendChild(link);
  });
};

// Register service worker
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
};

// Defer non-critical JavaScript
export const deferNonCriticalScripts = () => {
  const scripts = [
    'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.js',
    'https://api.mapbox.com/mapbox-gl-js/v2.6.1/mapbox-gl.js',
    'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js',
    // 'https://ws.colissimo.fr/widget-colissimo/js/jquery.plugin.colissimo.min.js'
  ];

  // Load scripts after page load
  window.addEventListener('load', () => {
    scripts.forEach(src => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      document.body.appendChild(script);
    });
  });
};

// Image optimization helper
export const createOptimizedImageSrc = (src, width, quality = 80) => {
  // For production, you might want to use a service like Cloudinary or ImageKit
  // For now, return the original src
  return src;
};

// Critical CSS extraction (to be used during build)
export const getCriticalCSS = () => {
  return `
    body { 
      font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; 
      margin: 0; 
      background-color: #fff; 
      line-height: 1.6;
    }
    #root { 
      min-height: 100vh; 
    }
    .loading-spinner {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-family: 'Poppins', sans-serif;
      color: #671929;
    }
    /* Critical styles for header/navigation */
    .navbar {
      background-color: #671929;
      padding: 1rem 0;
    }
    /* LCP optimized hero section */
    .hero-section {
      min-height: 60vh;
      background-color: #f8f9fa;
      contain: layout style paint;
    }
    /* Image optimization classes */
    .optimized-picture img {
      max-width: 100%;
      height: auto;
      object-fit: cover;
    }
    .img-placeholder {
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
};

// Initialize all performance optimizations
export const initializePerformanceOptimizations = () => {
  preloadCriticalResources();
  registerServiceWorker();
  initializeLCPOptimizations();
};
